{
  "incidentsOverview": {
    "button": {
      "new": "New incident",
      "columns": "Columns",
      "download": "Download GeoJSON"
    },
    "tooltip": {
      "edit": "Edit incident",
      "preview": "View incident"
    },
    "empty": "No incidents for this region.",
    "loading": "Loading incidents…",
    "error": "Incidents could not be loaded.",
    "retry": "Retry",
    "filter": {
      "anyStatus": "Any status"
    }
  },
  "incidentReportUI": {
    "addAttachment": "Add Attachment",
    "addAvalancheProblem": "Add Avalanche Problem",
    "addGroup": "Add Group",
    "addVictim": "Add Person",
    "back": "Atrás",
    "clearLine": "Clear Line",
    "clearPoint": "Clear Point",
    "clearPolygon": "Clear Polygon",
    "controls": "Controls",
    "deleteIncident": "Delete incident",
    "deleteIncidentConfirm": "Do you want to delete this incident?",
    "drawLine": "Draw Line",
    "drawLineInstructions": "Click on the map to add points to the line.",
    "drawPoint": "Draw Point",
    "drawPointInstructions": "Click anywhere on the map to place the location marker, then drag it to reposition.",
    "drawPolygon": "Draw Polygon",
    "drawPolygonInstructions": "Click on the map to define the corners/vertices of the polygon.",
    "dropAttachment": "Drop attachment {{fileName}}?",
    "dropAvalancheProblem": "Drop avalanche problem {{number}}?",
    "dropGroup": "Drop group {{number}}?",
    "dropVictim": "Drop person {{number}}?",
    "fetchPublishedBulletin": "Fetch from published CAAML bulletin",
    "fetchPublishedBulletinError": "No published CAAML bulletin could be fetched for {{region}} on {{date}}.",
    "fetchPublishedBulletinSuccess": "Updated bulletin information with {{count}} avalanche problems for {{region}} on {{date}}.",
    "groupName": "Group {{name}}",
    "groupUnknown": "Group unknown",
    "incomplete": "Incompleto",
    "line": "Line",
    "locationMap": "Location Map",
    "noGroups": "No groups registered. Click \"Add Group\" to add a group.",
    "next": "Siguiente",
    "overview": "Overview",
    "noVictims": "No persons registered. Click \"Add Person\" to add a person.",
    "point": "Point",
    "polygon": "Polygon",
    "publishIncident": "Publicar",
    "publishIncidentConfirm": "Do you want to publish this incident?",
    "publishIncidentSuccess": "The incident report has been published successfully.",
    "republishIncident": "Republish",
    "republishIncidentConfirm": "Do you want to republish this incident?",
    "unpublishIncident": "Unpublish",
    "unpublishIncidentConfirm": "Do you want to unpublish this incident?",
    "unpublishIncidentSuccess": "The incident report has been unpublished successfully.",
    "removeAttachment": "Remove Attachment",
    "removeAvalancheProblem": "Remove Avalanche Problem",
    "removeGroup": "Remove Group",
    "removeVictim": "Remove Person",
    "requiredFieldsMissingHint": "The report cannot be saved and its status cannot be changed until all required fields (marked in the form) are filled in.",
    "displayMode": {
      "edit": "Editar",
      "editMostRelevant": "Edit most relevant",
      "all": "Preview all",
      "public": "Preview public only",
      "filledOut": "Preview filled out only"
    },
    "victimName": "Person {{name}}",
    "saveStateSaving": "Saving…",
    "saveStateSaved": "Saved successfully",
    "saveStateError": "Save failed",
    "saveStateBlocked": "Not saved — required fields are missing"
  },
  "incidentReport": {
    "incidentReport": "Incident Report",
    "metaInformation": "Meta Information",
    "generalInformation": "General Information",
    "bulletinInformation": "Bulletin Information",
    "locationInformation": "Location Information",
    "avalancheInformation": "Avalanche Information",
    "groupInformation": "Group Information",
    "victimInformation": "Person Information",
    "involvementsFatalitiesBurials": "Involvements, Fatalities, and Burials",
    "incidentAnalysis": "Incident Analysis",
    "incidentAttachments": "Attachments and Links",
    "author": "Autor",
    "authorAffiliation": "Author Affiliation",
    "dateTime": "Date/Time",
    "updatedAt": "Last updated",
    "publishedAt": "Published at",
    "timeAccuracy": "Time Accuracy ",
    "sourceOfInformation": "Source of Information",
    "personInvolvement": "Person Involvement",
    "otherDamages": "Other Damages",
    "damagedAssets": "Damaged Assets",
    "otherDamagesComment": "Other Damages Comment",
    "publicAvalancheWarningService": "Public Avalanche Warning Service",
    "publicAvalancheWarningServiceOutside": "Outside AWS Forecast Area",
    "dangerRating": "Clasificación del peligro",
    "avalancheProblem": "Problema de aludes",
    "problemType": "Problema de aludes",
    "aspects": "Orientaciones",
    "elevationLowerBound": "Límite inferior de altitud",
    "elevationUpperBound": "Límite superior de altitud",
    "snowpackStability": "Estabilidad del manto nivoso",
    "frequency": "Frecuencia",
    "dangerPattern": "Patrón de peligro",
    "reportStatus": "Report Status",
    "publicExternalLinks": "Public External Links",
    "privateExternalLinks": "Private External Links",
    "privateExternalDatabaseLinks": "Link to External Databases",
    "generalInformationComment": "General Information Comment",
    "bulletinInformationComment": "Bulletin Information Comment",
    "location": "Localización",
    "country": "Country",
    "region": "Región",
    "municipality": "Municipality",
    "avalancheRegion": "Avalanche Region",
    "latitude": "Laltitud",
    "longitude": "Longitud",
    "locationAccuracy": "Location Accuracy",
    "lineCoordinatesText": "Line Coordinates",
    "polygonCoordinatesText": "Polygon Coordinates",
    "locationInformationComment": "Location Information Comment",
    "locationType": {
      "Point": "Point",
      "Line": "Line",
      "Polygon": "Polygon"
    },
    "anonymousGroupIdentifier": "Anonymous Group Identifier",
    "groupAffiliation": "Group affiliation",
    "groupType": "Group Type",
    "groupSize": "Group Size",
    "groupSizeAccuracy": "Group Size Accuracy",
    "incidentTerrainType": "Terrain Type",
    "typeOfControlledTerrain": "Type of Controlled Terrain",
    "incidentActivity": "Activity",
    "travelDirection": "Travel Direction",
    "vehicleType": "Vehicle Type",
    "avalancheGear": "Avalanche Gear",
    "groupInformationComment": "Group Information Comment",
    "numberOfGroups": "Number of groups",
    "activities": "Activities",
    "terrainTypes": "Terrain Types",
    "fatalities": "Fatalities",
    "injuredSurvivors": "Injured Survivors",
    "uninjuredSurvivors": "Uninjured Survivors",
    "caughtOnly": "Caught Only",
    "fullyBuried": "Fully Buried",
    "partlyBuriedHeadCovered": "Partly Buried, Head Covered",
    "partlyBuriedHeadUncovered": "Partly Buried, Head Uncovered",
    "partlyBuried": "Partly Buried",
    "numberInvolved": "Number Involved",
    "involvementsFatalitiesBurialsComment": "Involvements, Fatalities and Burials Comment",
    "caught": "Caught",
    "fatalInjured": "Fatal/Injured",
    "burialDegree": "Burial Degree",
    "anonymousVictimIdentifier": "Anonymous Person Identifier ",
    "age": "Age",
    "gender": "Gender",
    "workingAtTime": "Working At Time",
    "leaderAtTime": "Leader At Time",
    "professionalCertification": "Professional Certification",
    "avalancheTraining": "Avalanche Training",
    "yearsActive": "Years Active",
    "transceiver": "Transceiver",
    "shovel": "Shovel",
    "probe": "Probe",
    "airbag": "Airbag",
    "helmet": "Helmet",
    "terrainTrap": "Terrain trap",
    "burialDepth": "Burial Depth",
    "burialDuration": "Burial Duration",
    "primaryLocationMethod": "Primary Location Method",
    "rescuedBy": "Rescued/Recovered by",
    "medicalIntervention": "Medical Intervention",
    "estimatedTimeOfDeath": "Estimated Time Of Death",
    "causeOfDeath": "Cause of Death",
    "respiratoryCavity": "Respiratory Cavity",
    "injurySeverity": "Injury Severity",
    "victimInformationComment": "Victim Information Comment",
    "multipleAvalanches": "Multiple Avalanches",
    "avalancheSize": "Tamaño de alud",
    "avalancheType": "Avalanche Type",
    "relevantAvalancheProblem": "Relevant Avalanche Problem",
    "trigger": "Trigger",
    "natural": "Natural",
    "person": "Person",
    "additionalLoad": "Additional Load",
    "explosives": "Explosives",
    "vehicle": "Vehicle",
    "accidentalControlled": "Accidental/ Controlled",
    "remoteTriggering": "Remote Triggering",
    "startZoneAspect": "Start Zone Aspect",
    "startZoneAspectAccuracy": "Aspect Accuracy",
    "startZoneElevation": "Start Zone Elevation",
    "startZoneElevationAccuracy": "Elevation Accuracy",
    "startZoneIncline": "Start Zone Incline",
    "startZoneTerrainType": "Start Zone Terrain Type",
    "slabWidth": "Slab Width",
    "crownDepthAvg": "Crown Depth Avg",
    "crownDepthMin": "Crown Depth Min",
    "crownDepthMax": "Crown Depth Max",
    "avalancheLength": "Avalanche Lenght",
    "weakLayerName": "Weak Layer Name",
    "weakLayerGrainType1": "Weak Layer Grain Type (1)",
    "weakLayerGrainSize1": "Weak Layer Grain Size (1)",
    "weakLayerGrainType2": "Weak Layer Grain Type (2)",
    "weakLayerGrainSize2": "Weak Layer Grain Size (2)",
    "weakLayerLocation": "Weak layer Location",
    "bedSurfaceStepped": "Bed Surface Stepped",
    "startZoneMoisture": "Start Zone Moisture",
    "depositMoisture": "Deposit Moisture",
    "depositHeight": "Deposit Height",
    "depositWidth": "Deposit Width",
    "debrisType": "Debris Type",
    "debrisDensity": "Debris Density",
    "depositElevation": "Deposit Elevation",
    "avalancheDetailsComment": "Avalanche Details Comment",
    "incidentLedePublic": "Publish Incident Lede?",
    "incidentLede": "Incident Lede",
    "incidentDescriptionPublic": "Publish Incident Description?",
    "incidentDescription": "Incident Description",
    "weatherDescriptionPublic": "Publish Weather Description?",
    "weatherDescription": "Weather Description",
    "avalancheDescriptionPublic": "Publish Avalanche Description?",
    "avalancheDescription": "Avalanche Description",
    "snowpackDescriptionPublic": "Publish Snowpack Description?",
    "snowpackDescription": "Snowpack Description",
    "takeAwaysPublic": "Publish Take Aways?",
    "takeAways": "Take Aways",
    "recentSlabAvalanches": "Recent Slab Avalanches",
    "signsOfInstability": "Signs of Instability",
    "recentLoading": "Recent Loading",
    "criticalWarming": "Critical Warming",
    "incidentAnalysisComment": "Incident Analysis Comment",
    "uuid": "UUID",
    "dateAdded": "Date Added",
    "dateCreated": "Date Created",
    "file": "File",
    "fileName": "File Name",
    "mediaType": "Media Type",
    "attachmentTags": "Tags",
    "altText": "Alt Text",
    "credit": "Credit",
    "caption": "Caption",
    "public": "Public",
    "attachmentCategory": "Category"
  },
  "incidentReportHelp": {
    "author": "",
    "authorAffiliation": "",
    "dateTime": "",
    "timeAccuracy": "Specify the accuracy of the date/ time of the avalanche.",
    "sourceOfInformation": "Specify the source(s) of the information.",
    "personInvolvement": "Select “Yes” if the avalanche was human-triggered (including remote triggering) or if individuals were affected by moving masses.",
    "otherDamages": "Select “Yes” if the avalanche caused damage to property or other valuable assets.",
    "damagedAssets": "Indicate the type of object(s) that sustained damage.",
    "otherDamagesComment": "Add any additional details about the damaged assets.",
    "publicAvalancheWarningService": "Name of agency in which area of responsibility the avalanche happened.",
    "publicAvalancheWarningServiceOutside": "Check if the incident occurred outside any AWS forecast area.",
    "dangerRating": "Publicly available avalanche danger rating valid for the date, time, and location of the incident (including elevation and aspect, if applicable).",
    "avalancheProblem": "Select the forecasted EAWS Avalanche Problem(s) for that day and location. Choose “None” if none were issued that day.",
    "problemType": "Select the forecasted EAWS Avalanche Problem(s) for that day and location. Choose “None” if none were issued that day.",
    "aspects": "",
    "elevationLowerBound": "",
    "elevationUpperBound": "",
    "snowpackStability": "",
    "frequency": "",
    "dangerPattern": "Select the forecasted Danger Pattern(s) for that day and location.",
    "reportStatus": "Draft: Not ready for public view; initial entry phase; Incomplete: Not all information has been entered or received; visible to the public but may contain unverified information; In Review: All information has been entered; awaiting review by a supervisor; Complete: All available information has been added; final status.",
    "publicExternalLinks": "",
    "privateExternalLinks": "",
    "privateExternalDatabaseLinks": "Links this incident with other databases.",
    "generalInformationComment": "Add any additional relevant details.",
    "bulletinInformationComment": "Add any additional relevant details.",
    "location": "Brief description of the location. Use the name of the nearest mountain or a prominent geographic feature.",
    "country": "",
    "region": "",
    "municipality": "",
    "avalancheRegion": "Micro-Regions",
    "latitude": "Provide the coordinates of the center of the fracture crown.",
    "longitude": "Provide the coordinates of the center of the fracture crown.",
    "locationAccuracy": "Estimate the accuracy of the latitude/longitude coordinates.",
    "lineCoordinatesText": "Provide coordinates (one latitude, longitude pair per line) for the avalanche path.",
    "polygonCoordinatesText": "Provide coordinates (one latitude, longitude pair per line) for the avalanche outline.",
    "locationInformationComment": "Add any additional relevant details.",
    "anonymousGroupIdentifier": "This is used to identify the group throughout the report. For example, you might refer to Group 1, Group 2, etc when reporting on a incident. You could add specific details if it helps keep track of which group is which. If appropriate, you can use the same identifier when referencing this group in the Incident Description.",
    "groupAffiliation": "Select the group the person belonged to.",
    "groupType": "Select the option that best describes the type of group.",
    "groupSize": "Provide the total number of individuals in the group.",
    "groupSizeAccuracy": "Indicate how accurately the group size is known.",
    "incidentTerrainType": "Select the terrain type where people were located at the time of the avalanche. Free terrain refers to areas without any human infrastructure.",
    "typeOfControlledTerrain": "",
    "incidentActivity": "",
    "travelDirection": "Direction of travel at the time of the incident.",
    "vehicleType": "",
    "avalancheGear": "Essential avalanche rescue gear is defined as a transceiver, shovel and probe. Give a basic assessment of whether the group was carrying essential avalanche rescue gear. Commonly this information comes from the search and rescue team. It is not necessary to get hung up on exact numbers or require in-depth communication with each party member. More like an answer to the basic question of: Were they carrying rescue gear?.",
    "groupInformationComment": "Add any additional relevant details.",
    "numberOfGroups": "Number of groups involved",
    "activities": "",
    "terrainTypes": "",
    "fatalities": "All deceased whether they died on scene or afterwards as a result of their injuries.",
    "injuredSurvivors": "Number people who were caught by the avalanche and who were injured but not killed. Do not include any deceased.",
    "uninjuredSurvivors": "Number of people who were caught by the avalanche but not injured. Include those dusted by the powder cloud.",
    "caughtOnly": "Number of people who were caught by the avalanche but not buried. Include those dusted by the powder cloud.",
    "fullyBuried": "Number of people fully buried by the avalanche. A fully buried person has no part of their body visible.",
    "partlyBuriedHeadCovered": "Number of people buried with their head covered by snow but part of their body, clothing or attached equipment is visible.",
    "partlyBuriedHeadUncovered": "Number of people buried with their head uncovered.",
    "partlyBuried": "Number=Partly Buried, Head Covered+Partly Buried, Head Uncovered",
    "numberInvolved": "Number=Caught Only+Fully Buried+Partly Buried",
    "involvementsFatalitiesBurialsComment": "Add any additional relevant details",
    "caught": "Specify whether this individual was involved with the avalanche. Involved means being caught by the avalanche (whether buried or not), buried or dusted by the powder cloud.",
    "fatalInjured": "Indicate whether the person was fatally injured, injured, or uninjured, regardless of their involvement type.",
    "burialDegree": "Provide details about the degree of burial. A fully buried victim has all parts of their body submerged under the snow. If the victim was partly buried, try to find out whether their head was covered or uncovered and use these options preferentially. If you are unable to find out this detail, use the Partly Buried option.",
    "anonymousVictimIdentifier": "This is used to identify the victim throughout the report, without needing to use their name. For example, you might refer to Rider 1, Rider 2, etc when reporting on a snowmobile incident. You could add specific details if it helps keep track of which victim is which, e.g. Male survivor, Female survivor, Male decedant. If appropriate, you can use the same identifier when referencing this person in the Incident Description.",
    "age": "",
    "gender": "",
    "workingAtTime": "Was the person involved performing work duties at the time of the incident, either in a paid capacity or as a volunteer?",
    "leaderAtTime": "Was the person involved acting in a capacity that clearly placed them at the leader of the group?",
    "professionalCertification": "Provide details of the professional certification of the individual",
    "avalancheTraining": "Provide details about the highest level of avalanche safety training the victim had received.",
    "yearsActive": "Select how many years this person had been practicing the activity prior to the incident",
    "transceiver": "Select whether the person carried a transceiver and whether it was in send mode",
    "shovel": "",
    "probe": "",
    "airbag": "",
    "helmet": "",
    "terrainTrap": "Indicate the type of terrain trap involved, if there was one.",
    "burialDepth": "Specify the depth of burial in m to the nearerst 0.1 m. The reference to determine the burial depth is the depth from the snow surface to the victim's airway.",
    "burialDuration": "Specify the duration of the victim's burial in minutes from when they were first buried to when their airway was uncovered.",
    "primaryLocationMethod": "Specify the primary method that was used to locate the victim. ",
    "rescuedBy": "",
    "medicalIntervention": "Provide details about medical interventions applied, either by party members, or external rescue.",
    "estimatedTimeOfDeath": "Provide a best estimate of when the victim died. This does not have to be consistent with the official time of death, since in many instances, people are only pronounced dead at hospital.",
    "causeOfDeath": "Estimated cause of death",
    "respiratoryCavity": "No obstacles in the airways",
    "injurySeverity": "Major: a serious, often life-threatening condition that requires immediate medical attention and may result in long-term disability or death (e.g. fractures, head injuries, loss of conscousness, heavy bleeding); Moderate: more serious than minor but not immediately life-threatening. It usually needs medical treatment, but recovery is expected without major long-term effects (e.g. dislocations, sprains and strains, deep cuts). Minor: slight injury that can be treated with basic first aid, does not require professional medical care (e.g. small cuts, scratches, bruises).",
    "victimInformationComment": "Add any additional relevant details",
    "multipleAvalanches": "Choose yes, if there were multiple avalanches associated with the event. If selected, input details of the most impactful avalanche in the Avalanche Details section and provide details of the other avalanches in the Avalanche Comments section.",
    "avalancheSize": "Estimate the destructive potential of the avalanche based on the deposited snow and assign a size according to the EAWS standard. Size 1 is the minimum rating. Half sizes are generally not defined, but may be used for avalanches that fall between two size classes; they are assigned to the lower class (e.g. size 2.5 is classified as size 2).",
    "avalancheType": "Specify the avalanche type from the list according to it's failure type. If more than one type applies, choose the most relevant one and add further detail to the Incident Description.",
    "relevantAvalancheProblem": "Select the most relevant EAWS Avalanche Problem.",
    "trigger": "Natural: Triggered without human influence; Person: Triggered by one or more people; Explosives: Triggered by explosives, artillery, or gas; Vehicle: Triggered by a vehicle (e.g. snowcat, helicopter); Unknown: Trigger is unknown or unclear",
    "natural": "Natural: Triggered by weather events (e.g. snowfall, wind, temperature); Cornice fall: Triggered by naturally collapsing cornice; Earthquake: Triggered by an earthquake; Ice fall: Triggered by collapsed ice; Rock fall: Triggered by rockfall event",
    "person": "Accidental: e.g. skier, snowboarder, hiker, climber; Controlled: e.g. skier deliberately ski cutting a slope or cornice",
    "additionalLoad": "Low additional load: single skier/snowboarder, well-spaced group ≥10 m, or snowshoer; High additional load: closely spaced group <10 m,  single person on foot, falling skier/snowboarder.",
    "explosives": "",
    "vehicle": "",
    "accidentalControlled": "",
    "remoteTriggering": "A remote event is one occurring at some distance (typically > 5 m) from the probable trigger. Snow at the trigger point does not release",
    "startZoneAspect": "Specify the aspect of the start zone. If the avalanche wraps around multiple aspects, use the median aspect and add further details to the Incident Description.",
    "startZoneAspectAccuracy": "Indicate whether the aspect of the start zone is accurate or uncertain. Uncertainty applies if deviations greater than ±30° are possible.",
    "startZoneElevation": "Provide the elevation of the avalanche fracture line in meters above sea level (m a.s.l.), using the highest point rounded to the nearest multiple of 50m (e.g. 2550, 2600m).",
    "startZoneElevationAccuracy": "",
    "startZoneIncline": "Slope angle of the start zone (°), rounded to the nearest 5° (e.g. 30, 35, 40)",
    "startZoneTerrainType": "Select the terrain features that describe the avalanche start zone.",
    "slabWidth": "Slab width in m. This may be estimated from field reports or measured from mapping using coordinates from the flanks.",
    "crownDepthAvg": "Average crown depth cm to the nearest 10cm - measured vertically. This may be estimated from field reports (if only one number for the crown depth is supplied, it is usually taken to be the average), or it may be appropriate to calculate this from the min and max crown depth values.",
    "crownDepthMin": "Minimum crown depth cm to the nearest 10cm - measured vertically. Typically estimated from field reports.",
    "crownDepthMax": "Maximum crown depth cm to the nearest 10cm - measured vertically. Typically estimated from field reports.",
    "avalancheLength": "Runout distance along the ground from the highest point of the crown to the lowest point of deposition (m). This can be estimated from field observations or measured using mapped coordinates of the start zone and terminus.",
    "weakLayerName": "Record the weak layer name if known.",
    "weakLayerGrainType1": "Primary weak layer grain type.",
    "weakLayerGrainSize1": "Grain size to the nearest 0.25 mm.",
    "weakLayerGrainType2": "Secondary weak layer grain type.",
    "weakLayerGrainSize2": "Grain size to the nearest 0.25 mm.",
    "weakLayerLocation": "Within new snow: Weak layer located within recently fallen and wind-drifted snow from the current snowfall or deposition period; At interface with old snow: Weak layer at the boundary between new and old snow (e.g. surface hoar on the old snow surface before being covered); Within the old snowpack: Weak layer in the middle or upper part of the old snowpack; Near the ground: Weak layer in the lower part of the snowpack, close to the ground, typically consisting of well-developed faceted crystals. Avalanches releasing on this layer often expose the ground.",
    "bedSurfaceStepped": "Select “Yes” if the avalanche stepped down into a deeper weak layer.",
    "startZoneMoisture": "",
    "depositMoisture": "",
    "depositHeight": "Maximum height of the deposit",
    "depositWidth": "Maximum width of the deposit",
    "debrisType": "Select the options that best describe the composition of the debris shortly after the avalanche.",
    "debrisDensity": "Density of the debris, expressed as the median of several measurements taken at different locations within the debris.",
    "depositElevation": "Elevation of the lowest point of the deposition in m.a.s.l.",
    "avalancheDetailsComment": "Add any additional relevant details",
    "incidentLedePublic": "",
    "incidentLede": "Short text (500 characters max) that provides the essence of the incident. State what happened, where and when it occurred, and why it is notable. Keep it concise and factual, highlighting the most important outcome (e.g. involvement, burial, fatalities, unusual conditions).",
    "incidentDescriptionPublic": "",
    "incidentDescription": "Describe the incident in a clear, chronological manner, avoiding judgement or blame. Include what the group was doing at the time; where they were located (terrain, elevation, aspect if known); how the avalanche was triggered; how many people were involved, buried, injured or killed; who responded; and key details of the rescue. Include any other relevant observations that help reconstruct the event.",
    "weatherDescriptionPublic": "",
    "weatherDescription": "Describe the weather conditions that influenced the avalanche, including factors such as weak layer formation, slab development, recent loading, or warming. Link to relevant attachments (e.g. weather station data or graphs).",
    "avalancheDescriptionPublic": "",
    "avalancheDescription": "Describe the avalanche(s) itself using clear and objective terms. Include avalanche type, size, and dimensions (e.g. width, crown depth, runout). Note how it was triggered (natural, human-triggered, remote) and how it behaved (e.g. propagation, extent). Include any measurable or observed characteristics. Use the Incident Description to provide details about how and where people were caught, rescue details etc.",
    "snowpackDescriptionPublic": "",
    "snowpackDescription": "Explain the snowpack structure and conditions that contributed to the avalanche. Identify relevant weak layers and slab characteristics, and describe their distribution (e.g. by elevation or aspect). Include signs of instability and any available test results. Focus on explaining why the snowpack was susceptible to failure.",
    "takeAwaysPublic": "",
    "takeAways": "Summarize the key takeaways of the incident in a few short bullet points. Consider aspects such as warning signs, risk management (e.g. skiing one at a time), use of safety equipment, terrain traps, and group composition.",
    "recentSlabAvalanches": "Use your best judgement to answer the question: Are there signs of slab avalanches in the area from today or yesterday? Look to information provided by the group themselves, reports from SAR teams or other users of the area that indicate whether other avalanches were noted.",
    "signsOfInstability": "Use your best judgement to answer the question: Are there signs of snowpack instability including whumpfs, shooting cracks or drum-like sounds? Look to information provided by the group themselves, reports from SAR teams or other users of the area that indicate whether signs of instability were noted.",
    "recentLoading": "Use your best judgement to answer the question: Has there been loading within the past 48 hours including roughly 30 cm of new snow or more, significant wind transport or rain?",
    "criticalWarming": "Use your best judgement to answer the question: Has there been a recent rapid rise in temperature to near 0 C, or is the upper snowpack wet due to strong sun, above-freezing air temperatures or rain?",
    "incidentAnalysisComment": "For further information",
    "uuid": "UUID",
    "dateAdded": "Date is derived from when the attachment was uploaded",
    "dateCreated": "Date when the attachment was captured or created",
    "file": "File",
    "fileName": "Derived from original file name of uploaded attachment",
    "mediaType": "",
    "attachmentTags": "",
    "altText": "",
    "credit": "",
    "caption": "",
    "public": "",
    "attachmentCategory": ""
  },
  "sourceOfInformation": {
    "PublicObservation": "Public Observation",
    "AWSInternal": "AWS Internal",
    "AWSObserver": "AWS Observer",
    "DispatchCentre": "Dispatch Centre",
    "Police": "Police",
    "MountainRescue": "Mountain Rescue",
    "Other": "Other"
  },
  "personInvolvement": {
    "Yes": "Event involving persons",
    "No": "Event not involving persons",
    "Unknown": "Event (unknown)"
  },
  "otherDamages": {
    "Yes": "Si",
    "No": "No"
  },
  "damagedAssets": {
    "Vehicle": "Vehicle",
    "Forest": "Forest",
    "Agriculture": "Agriculture",
    "Livestock": "Livestock",
    "UtilitiesTechnicalInfrastructure": "Utilities or Technical Infrastructure",
    "ResidentialBuilding": "Residential Building",
    "Other": "Other"
  },
  "timeAccuracy": {
    "exact": "exacto",
    "PT15M": "± 15 min",
    "PT30M": "± 30 min",
    "PT1H": "± 1 h",
    "PT2H": "± 2 h",
    "PT4H": "± 4 h",
    "PT6H": "± 6 h",
    "PT12H": "± 12 h",
    "P1D": "± 1 d",
    "P2D": "± 2 d",
    "P3D": "± 3 d",
    "unknown": "desconocido"
  },
  "reportStatus": {
    "Draft": "Draft",
    "Incomplete": "Incompleto",
    "InReview": "In Review",
    "Verified": "Verified"
  },
  "locationAccuracy": {
    "exact": "exacto",
    "within15m": "± 15 m",
    "within30m": "± 30 m",
    "within100m": "± 100 m",
    "within250m": "± 250 m",
    "within500m": "± 500 m",
    "within1km": "± 1 km",
    "within2km": "± 2 km",
    "within5km": "± 5 km",
    "within10km": "± 10 km",
    "within20km": "± 20 km",
    "within50km": "± 50 km",
    "unknown": "desconocido"
  },
  "groupType": {
    "RecreationalFamilyFriends": "Recreational Family/Friends",
    "Club": "Club",
    "Commercial": "Commercial",
    "Industrial": "Industrial",
    "Solo": "Solo",
    "Unknown": "Unknown",
    "Other": "Other"
  },
  "groupSizeAccuracy": {
    "Exact": "Exact",
    "Approximately": "Approximately",
    "AtLeast": "At Least",
    "Unknown": "Unknown"
  },
  "incidentTerrainType": {
    "FreeTerrain": "Free Terrain",
    "ControlledTerrainOpen": "Controlled Terrain: Open",
    "ControlledTerrainClosed": "Controlled Terrain: Closed",
    "Unknown": "Unknown"
  },
  "typeOfControlledTerrain": {
    "IndoorInsideBuilding": "Indoor (Inside Building)",
    "Street": "Street",
    "TrainTrack": "Train Track",
    "SkiAreaResort": "Ski Area Resort",
    "CrossCountryTrack": "Cross Country Track",
    "SledgingTrack": "Sledging Track",
    "Other": "Other"
  },
  "incidentActivity": {
    "Touring": "Touring",
    "Freeriding": "Freeriding",
    "SkiingSnowboarding": "Skiing/Snowboarding",
    "Snowmobiling": "Snowmobiling",
    "Mountaineering": "Mountaineering",
    "IceClimbing": "Ice Climbing",
    "Snowshoeing": "Snowshoeing",
    "HikingOnFoot": "Hiking on Foot",
    "CrossCountrySkiing": "Cross Country Skiing",
    "HuntingFishing": "Hunting/Fishing",
    "Sledging": "Sledging",
    "Snowbiking": "Snowbiking",
    "Biking": "Biking",
    "InsideVehicle": "Inside Vehicle",
    "Unknown": "Unknown",
    "Other": "Other"
  },
  "travelDirection": {
    "Ascending": "Ascending",
    "Descending": "Descending",
    "Stationary": "Stationary",
    "Traversing": "Traversing",
    "MovingOnPeaksRidges": "Moving on peaks/ridges",
    "SnowmobileHighMarking": "Snowmobile High Marking",
    "CrossingRunouts": "Crossing Runouts",
    "Other": "Other"
  },
  "vehicleType": {
    "Car": "Car",
    "Bus": "Bus",
    "SnowPlower": "Snow Plower",
    "Snowcat": "Snowcat",
    "Other": "Other"
  },
  "avalancheGear": {
    "All": "Todos",
    "Some": "Algunas",
    "None": "Ninguno",
    "Unknown": "Unknown"
  },
  "natural": {
    "Natural": "Natural (result of weather events, e.g. snowfall, wind temperature)",
    "CorniceFall": "Cornice fall, natural",
    "Earthquake": "Earthquake",
    "IceFall": "Ice fall",
    "RockFall": "Rock fall"
  },
  "person": {
    "PersonAccidental": "Accidental",
    "PersonControlled": "Controlled"
  },
  "explosives": {
    "Artillery": "Artillery",
    "CaseCharge": "Case (bag) charge placed below slope",
    "CorniceControlledByExplosives": "Cornice controlled by explosives",
    "HelicopterDeployedGasExploder": "Helicopter deployed gas exploder (e.g., Daisybell)",
    "HandThrownOrPlaced": "Hand-thrown or hand-placed explosive charge",
    "GasExploder": "Gas exploder",
    "HelicopterBomb": "Helicopter bomb",
    "Avalauncher": "Avalauncher and other types of launchers",
    "PrePlacedRemotelyDetonated": "Pre-placed remotely detonated explosive charge",
    "TramOrRopewayDelivery": "Tram or ropeway delivery system",
    "Other": "Other"
  },
  "vehicle": {
    "OverSnowVehicle": "Over-snow vehicles (snowcats, maintenance equipment, etc.)",
    "Snowmobile": "Snowmobile",
    "Helicopter": "Helicopter (e.g. on landing, approach)",
    "Other": "Other"
  },
  "startZoneElevationAccuracy": {
    "exact": "exacto",
    "within50m": "± 50 m",
    "within100m": "± 100 m",
    "within200m": "± 200 m",
    "unknown": "desconocido"
  },
  "startZoneTerrainType": {
    "AlpineBowl": "Alpine Bowl",
    "Couloir": "Couloir",
    "NearRidgeCrest": "Near Ridge Crest",
    "SparselyTreed": "Sparsely Treed",
    "OpenForest": "Open Forest",
    "DenseForest": "Dense Forest",
    "ForestGlade": "Forest Glade",
    "Glacier": "Glacier",
    "OpenSlope": "Open Slope",
    "Ridge": "Ridge",
    "ExtremeRockyTerrain": "Extreme Rocky Terrain",
    "BaseOfRockFace": "Base of Rock Face",
    "WoodPath": "Wood Path",
    "LeewardSlope": "Leeward Slope",
    "WindwardSlope": "Windward Slope",
    "IceWaterfall": "Ice Waterfall",
    "Other": "Other"
  },
  "weakLayerLocation": {
    "WithinNewSnow": "Within new snow",
    "AtInterfaceWithOldSnow": "At the Interface with Old Snow",
    "WithinOldSnowpack": "Within the Old Snowpack",
    "NearTheGround": "Near the Ground"
  },
  "debrisType": {
    "Fine": "Fine",
    "Blocks": "Blocks",
    "Hard": "Dura",
    "Soft": "Soft",
    "Rocks": "Rocks",
    "Trees": "Trees",
    "Other": "Other"
  },
  "startZoneMoisture": {
    "Dry": "Seca",
    "Moist": "Moist",
    "Wet": "Húmeda",
    "Unknown": "Unknown"
  },
  "depositMoisture": {
    "Dry": "Seca",
    "Moist": "Moist",
    "Wet": "Húmeda"
  },
  "bedSurfaceStepped": {
    "Yes": "Si",
    "No": "No"
  },
  "multipleAvalanches": {
    "Yes": "Si",
    "No": "No"
  },
  "avalancheType": {
    "slab": "slab",
    "loose": "loose",
    "glide": "glide",
    "cornice": "cornice",
    "unknown": "unknown"
  },
  "avalancheSize": {
    "small": "small",
    "small_medium": "small–medium",
    "medium": "medium",
    "medium_large": "medium–large",
    "large": "large",
    "large_very_large": "large–very large",
    "very_large": "very large",
    "very_large_extreme": "very large–extreme",
    "extreme": "extreme",
    "unknown": "unknown"
  },
  "trigger": {
    "natural": "Natural",
    "person": "Person",
    "explosives": "Explosives",
    "vehicle": "Vehicle",
    "unknown": "Unknown",
    "Other": "Other"
  },
  "startZoneAspectAccuracy": {
    "Accurate": "Accurate",
    "Uncertain": "Uncertain"
  },
  "remoteTriggering": {
    "Yes": "Si",
    "No": "No"
  },
  "additionalLoad": {
    "High": "High",
    "Low": "Low"
  },
  "accidentalControlled": {
    "Accidental": "Accidental",
    "Controlled": "Controlled"
  },
  "caught": {
    "Involved": "Involved",
    "NotInvolved": "Not Involved",
    "Unknown": "Unknown"
  },
  "fatalInjured": {
    "Fatal": "Fatal",
    "Injured": "Injured",
    "Uninjured": "Uninjured",
    "Unknown": "Unknown"
  },
  "burialDegree": {
    "FullyBuried": "Fully Buried",
    "PartlyBuriedHeadCovered": "Partly Buried, Head Covered",
    "PartlyBuriedHeadUncovered": "Partly Buried, Head Uncovered",
    "PartlyBuried": "Partly Buried",
    "NotBuried": "Not Buried",
    "Unknown": "Unknown"
  },
  "age": {
    "UpTo13": "≤ 13",
    "From14To20": "14–20",
    "From21To30": "21–30",
    "From31To40": "31–40",
    "From41To50": "41–50",
    "From51To60": "51–60",
    "From61To70": "61–70",
    "From71": "≥ 71"
  },
  "gender": {
    "Female": "Female",
    "Male": "Male",
    "Other": "Other"
  },
  "country": {
    "Austria": "Austria",
    "Germany": "Alemania",
    "Italy": "Italia",
    "Switzerland": "Suiza",
    "Other": "Other"
  },
  "workingAtTime": {
    "Yes": "Si",
    "No": "No"
  },
  "leaderAtTime": {
    "Yes": "Si",
    "No": "No"
  },
  "professionalCertification": {
    "None": "None",
    "IFMGAGuide": "IFMGA Guide",
    "FullSkiGuide": "Full Ski guide",
    "SkiInstructor": "Ski Instructor",
    "ApprenticeGuide": "Apprentice Guide",
    "AvalancheProfessional": "Avalanche Professional",
    "AvalancheEducator": "Avalanche Educator",
    "Other": "Other"
  },
  "avalancheTraining": {
    "None": "Ninguno",
    "Awareness": "Awareness",
    "BasicREC": "Basic REC",
    "AdvancedREC": "Advanced REC",
    "Professional": "Professional",
    "Other": "Other"
  },
  "yearsActive": {
    "UpTo2Years": "≤ 2 yrs",
    "From3To9Years": "3–9 yrs",
    "From10Years": "≥ 10 yrs"
  },
  "transceiver": {
    "NoTransceiver": "No Transceiver",
    "TransceiverOn": "Transceiver: on",
    "TransceiverOff": "Transceiver: off"
  },
  "shovel": {
    "Yes": "Si",
    "No": "No"
  },
  "probe": {
    "Yes": "Si",
    "No": "No"
  },
  "airbag": {
    "NoAirbag": "No Airbag",
    "AirbagDeployed": "Airbag: deployed",
    "AirbagUndeployed": "Airbag: undeployed"
  },
  "helmet": {
    "Yes": "Si",
    "No": "No"
  },
  "terrainTrap": {
    "None": "Ninguno",
    "Cliff": "Cliff",
    "Trees": "Trees",
    "Gully": "Gully",
    "Depression": "Depression",
    "Bench": "Bench",
    "Boulder": "Boulder",
    "CrevasseOrBergschrund": "Crevasse or Bergschrund",
    "Other": "Other"
  },
  "primaryLocationMethod": {
    "NotBuried": "Not Buried",
    "SelfExtraction": "Self Extraction",
    "VisualClues": "Visual Clues",
    "TransceiverProbeShovel": "Transceiver/Probe/Shovel",
    "SpotProbing": "Spot Probing",
    "ProbeLine": "Probe Line",
    "Recco": "Recco",
    "RescueDog": "Rescue Dog",
    "Snowmelt": "Snowmelt",
    "Other": "Other"
  },
  "rescuedBy": {
    "Self": "Self",
    "Companion": "Companion",
    "OtherGroup": "Other Group",
    "OrganizedRescue": "Organized Rescue",
    "Unknown": "Unknown",
    "Other": "Other"
  },
  "medicalIntervention": {
    "CPR": "CPR",
    "ALS": "ALS",
    "ECMO": "ECMO",
    "Other": "Other"
  },
  "estimatedTimeOfDeath": {
    "DuringTheAvalanche": "During the avalanche",
    "DuringBurial": "During burial",
    "OnSiteAfterExtrication": "On site after extrication",
    "DuringTransport": "During transport",
    "InHospital": "In hospital"
  },
  "causeOfDeath": {
    "Asphyxiation": "Asphyxiation",
    "TraumaticInjury": "Traumatic injury",
    "Hypothermia": "Hypothermia",
    "Other": "Other"
  },
  "respiratoryCavity": {
    "Yes": "Si",
    "No": "No"
  },
  "injurySeverity": {
    "Minor": "Minor",
    "Moderate": "Moderate",
    "Major": "Major"
  },
  "recentSlabAvalanches": {
    "Present": "Present",
    "Absent": "Absent",
    "Unknown": "Unknown"
  },
  "signsOfInstability": {
    "Present": "Present",
    "Absent": "Absent",
    "Unknown": "Unknown"
  },
  "recentLoading": {
    "Present": "Present",
    "Absent": "Absent",
    "Unknown": "Unknown"
  },
  "criticalWarming": {
    "Present": "Present",
    "Absent": "Absent",
    "Unknown": "Unknown"
  },
  "attachmentTags": {
    "Picture": "Picture",
    "PoliceReport": "Police Report",
    "MedicalReport": "Medical Report",
    "Other": "Other"
  },
  "attachmentCategory": {
    "Incident": "Incidente",
    "Avalanche": "Alud",
    "Snowpack": "Manto nivoso",
    "Group": "Group",
    "Person": "Person",
    "Weather": "Tiempo atmosférico"
  }
}
